/**
 * Английский частотный список, упорядоченный по убыванию употребительности.
 *
 * Включены типовые сокращения с апострофом: без них навык не переносится в
 * реальный текст (ТЗ §8.2).
 */

export const EN_WORD_LIST: readonly string[] = [
  'the',
  'be',
  'to',
  'of',
  'and',
  'a',
  'in',
  'that',
  'have',
  'it',
  'for',
  'not',
  'on',
  'with',
  'he',
  'as',
  'you',
  'do',
  'at',
  'this',
  'but',
  'his',
  'by',
  'from',
  'they',
  'we',
  'say',
  'her',
  'she',
  'or',
  'an',
  'will',
  'my',
  'one',
  'all',
  'would',
  'there',
  'their',
  'what',
  'so',
  'up',
  'out',
  'if',
  'about',
  'who',
  'get',
  'which',
  'go',
  'me',
  'when',
  'make',
  'can',
  'like',
  'time',
  'no',
  'just',
  'him',
  'know',
  'take',
  'people',
  'into',
  'year',
  'your',
  'good',
  'some',
  'could',
  'them',
  'see',
  'other',
  'than',
  'then',
  'now',
  'look',
  'only',
  'come',
  'its',
  'over',
  'think',
  'also',
  'back',
  'after',
  'use',
  'two',
  'how',
  'our',
  'work',
  'first',
  'well',
  'way',
  'even',
  'new',
  'want',
  'because',
  'any',
  'these',
  'give',
  'day',
  'most',
  'us',
  'find',
  'here',
  'thing',
  'place',
  'right',
  'hand',
  'word',
  'life',
  'world',
  'part',
  'need',
  'home',
  'read',
  'write',
  'learn',
  'speed',
  'keyboard',
  'letter',
  'line',
  'error',
  'memory',
  'focus',
  'habit',
  'practice',
  'session',
  'target',
  'result',
  'answer',
  'question',
  'reason',
  'change',
  'small',
  'large',
  'long',
  'short',
  'early',
  'late',
  'high',
  'low',
  'open',
  'close',
  'light',
  'dark',
  'warm',
  'cold',
  'strong',
  'quick',
  'slow',
  'clear',
  'simple',
  'quiet',
  'city',
  'water',
  'child',
  'school',
  'friend',
  'family',
  'money',
  'story',
  'music',
  'paper',
  'today',
  'tomorrow',
  'yesterday',
  'morning',
  'evening',
  'night',
  'week',
  'month',
  'hour',
  'minute',
  'again',
  'always',
  'never',
  'often',
  'together',
  'around',
  'between',
  'before',
  'during',
  'without',
  "don't",
  "can't",
  "won't",
  "it's",
  "that's",
  "i'm",
  "you're",
  "we're",
  "they're",
  "isn't",
  "doesn't",
  "didn't",
  "haven't",
  "wouldn't",
  "couldn't",
  "shouldn't",
  "let's",
  "there's",
  "he's",
  "she's",
  // Words added for variety (stage ABL). This is the tail of the frequency
  // list: the exact rank here decides nothing. The short words at the end are
  // typable on the home row and the first unlocked groups — without them a
  // beginner on ten keys had fewer than ten words to practise on.
  'value',
  'level',
  'order',
  'rule',
  'plan',
  'goal',
  'step',
  'group',
  'number',
  'count',
  'limit',
  'edge',
  'start',
  'middle',
  'street',
  'road',
  'garden',
  'forest',
  'field',
  'river',
  'sea',
  'shore',
  'hill',
  'sky',
  'sun',
  'wind',
  'rain',
  'snow',
  'ice',
  'fire',
  'shade',
  'sound',
  'voice',
  'noise',
  'smell',
  'taste',
  'bread',
  'salt',
  'tea',
  'milk',
  'lunch',
  'dinner',
  'table',
  'chair',
  'door',
  'window',
  'wall',
  'floor',
  'corner',
  'shelf',
  'bag',
  'pocket',
  'notebook',
  'pen',
  'folder',
  'magazine',
  'song',
  'game',
  'sport',
  'run',
  'sleep',
  'rest',
  'health',
  'mother',
  'father',
  'sister',
  'brother',
  'son',
  'daughter',
  'guest',
  'doctor',
  'teacher',
  'student',
  'driver',
  'team',
  'society',
  'nation',
  'law',
  'contract',
  'price',
  'market',
  'shop',
  'goods',
  'choice',
  'address',
  'phone',
  'project',
  'program',
  'computer',
  'file',
  'network',
  'site',
  'page',
  'button',
  'finger',
  'palm',
  'wrist',
  'posture',
  'rhythm',
  'pace',
  'pause',
  'repeat',
  'review',
  'approach',
  'calmly',
  'evenly',
  'exactly',
  'easily',
  'slowly',
  'badly',
  'nearly',
  'lately',
  'rarely',
  'many',
  'few',
  'more',
  'less',
  'better',
  'worse',
  'further',
  'closer',
  'higher',
  'lower',
  'hold',
  'put',
  'carry',
  'walk',
  'sit',
  'stand',
  'fall',
  'grow',
  'fix',
  'build',
  'break',
  'lose',
  'keep',
  'trust',
  'help',
  'call',
  'ask',
  'promise',
  'shout',
  'whisper',
  'laugh',
  'cry',
  'breathe',
  'relax',
  'hurry',
  'try',
  'check',
  'remember',
  'forget',
  'notice',
  'choose',
  'compare',
  'own',
  'book',
  'under',
  'end',
  'last',
  'key',
  'old',
  'example',
  'decision',
  'condition',
  'quality',
  'experience',
  'movement',
  'lesson',
  'task',
  'fast',
  'meaning',
  'lad',
  'lads',
  'flag',
  'flags',
  'glad',
  'dash',
  'flash',
  'salad',
  'shall',
  'gas',
  'has',
  'had',
  'ash',
  'lash',
  'flask',
  'glass',
  'grass',
  'half',
  'hall',
  'falls',
  'add',
  'adds',
  'dad',
  'sad',
  'lag',
  'sag',
  'slash',
];
